import useSWR from 'swr';

import { authorizedFetcher } from 'src/utils/axios';

import { useAuthContext } from './use-auth-context';

const useAuthenticatedSWR = (endpoint, options = {}) => {
  const { user } = useAuthContext();
  const { tempToken, ...restOptions } = options;

  const fetcher = async (url) => {
    const token = tempToken || user?.accessToken;
    if (!token) {
      throw new Error('No access token available');
    }
    // authorizedFetcher already handles response transformation via axios interceptor
    return authorizedFetcher(url, token);
  };

  const shouldFetch = !!tempToken || !!user?.accessToken;

  const { data, error, isValidating, isLoading } = useSWR(
    shouldFetch ? endpoint : null,
    fetcher,
    restOptions
  );

  return { data: data || null, error, isValidating, isLoading };
};

export default useAuthenticatedSWR;